import { useCallback } from "react"
import { useFetcher } from "react-router"

import {
  SharedEvidenceThemesTab,
  type EvidenceThemesFetcherData,
  type EvidenceThemesFormValues,
} from "../shared/SharedEvidenceThemesTab"
import type { LoaderData, EvidenceThemesConfig } from "./brand-ui-config"

export function EvidenceThemesTab({ config, data }: { config: EvidenceThemesConfig | undefined; data: LoaderData }) {
  const fetcher = useFetcher<EvidenceThemesFetcherData>()
  const pendingAction = (fetcher.formData?.get("action") as "SAVE_SECTION" | "REMOVE_SECTION" | null) ?? null

  const handleSave = useCallback(
    (values: EvidenceThemesFormValues) => {
      const formData = new FormData()
      formData.append("action", "SAVE_SECTION")
      formData.append("organisation", data.loadedOrganisation)
      formData.append("brand", data.loadedBrand ?? "")
      formData.append("jsonPath", "$.evidenceThemes")
      formData.append(
        "value",
        JSON.stringify({
          ...values,
          filters: config?.filters ?? [],
        }),
      )
      formData.append("concurrency", data.config?.concurrency ?? "")
      fetcher.submit(formData, { method: "post" })
    },
    [fetcher, data, config?.filters],
  )

  const handleRemove = useCallback(() => {
    const formData = new FormData()
    formData.append("action", "REMOVE_SECTION")
    formData.append("organisation", data.loadedOrganisation)
    formData.append("brand", data.loadedBrand ?? "")
    formData.append("jsonPath", "$.evidenceThemes")
    formData.append("concurrency", data.config?.concurrency ?? "")
    fetcher.submit(formData, { method: "post" })
  }, [fetcher, data])

  return (
    <SharedEvidenceThemesTab
      config={config}
      data={data}
      fetcher={fetcher}
      pendingAction={pendingAction}
      onSave={handleSave}
      onRemove={handleRemove}
    />
  )
}
